import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { authSimpleCanActivate } from "@delon/auth";
import { LayoutDefaultComponent } from "src/app/layout/default/default.component";
import { ProfileComponent } from "./profile.component";
import { UserProfileComponent } from "./user-profile/user-profile.component";
import { SecretKeyGeneratorComponent } from "./secret-key-generator/secret-key-generator.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { DeleteAccountComponent } from "./delete-account/delete-account.component";
import { BioDataComponent } from "./bio-data/bio-data.component";
import { UserIdentificationComponent } from "./user-identification/user-identification.component";
import { InstitutionDetailComponent } from "./institution-detail/institution-detail.component";
import { CountrySetupComponent } from "./country-setup/country-setup.component";
import { verifierOnlyCanActivate } from "@core";

const routes: Routes = [
  {
    path: "",
    component: LayoutDefaultComponent,
    canActivate: [authSimpleCanActivate],
    children: [
      {
        path: '',
        component: ProfileComponent,
        children: [
          {
            path: "",
            redirectTo: "bio-data",
            pathMatch: "full",
          },
          {
            path: "user",
            component: UserProfileComponent,
            data: { title: "Profile", titleI18n: "PAGE_TITLES.PROFILE" },
          },
          {
            path: "api",
            component: SecretKeyGeneratorComponent,
            data: { title: "Profile", titleI18n: "PAGE_TITLES.PROFILE" },
          },
          {
            path: "change-password",
            component: ChangePasswordComponent,
            data: { title: "Profile", titleI18n: "PAGE_TITLES.PROFILE" },
          },
          {
            path: "delete",
            component: DeleteAccountComponent,
            data: { title: "Profile", titleI18n: "PAGE_TITLES.PROFILE" },
          },
          {
            path: "bio-data",
            component: BioDataComponent,
            data: { title: "Profile", titleI18n: "PAGE_TITLES.PROFILE" },
          },
          {
            path: "identification",
            component: UserIdentificationComponent,
            data: { title: "Profile", titleI18n: "PAGE_TITLES.PROFILE" },
          },
          {
            path: "institution-detail",
            component: InstitutionDetailComponent,
            data: { title: "Profile", titleI18n: "PAGE_TITLES.PROFILE" },
          },
          {
            path: "country-setup",
            component: CountrySetupComponent,
            canActivate: [verifierOnlyCanActivate],
            data: { title: "Profile", titleI18n: "PAGE_TITLES.PROFILE" },
          },
        ]
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProfileRoutingModule {}
